import Config from './config'
import { $post, $get } from './http'
import Store from '@/store'

const Api = {}

for (const key in Config.apis) {
    Api[key] = (params, props = {}) => {
        return new Promise((resolve, reject) => {
            const lan = Store.state.lang
            const token = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')).token : ''
            $post(Config.apiBaseUrl + Config.apis[key], params, {
                tenantId: lan === 'en' ? Config.enTenantId : Config.tenantId,
                'Authorization-API': token ? `bearer ${token}` : ''
            }).then((res) => {
                props.callback && props.callback(res)
                if (res.status === 0) {
                    resolve(res.data)
                } else {
                    !props.noToast && window.$toast && res.message && window.$toast(res.message)
                    reject(res.status)
                }
            }).catch((err) => {
                reject(err)
            })
        })
    }
    Api[`$get${key}`] = (params, props = {}) => {
        return new Promise((resolve, reject) => {
            const lan = Store.state.lang
            const token = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')).token : ''
            $get(Config.apiBaseUrl + Config.apis[key], params, {
                tenantId: lan === 'en' ? Config.enTenantId : Config.tenantId,
                'Authorization-API': token ? `bearer ${token}` : ''
            }).then((res) => {
                props.callback && props.callback(res)
                if (res.status === 0) {
                    resolve(res.data)
                } else {
                    !props.noToast && window.$toast && res.message && window.$toast(res.message)
                    reject(res.status)
                }
            }).catch((err) => {
                reject(err)
            })
        })
    }
}

export default Api